import { render, staticRenderFns } from "./observa4PrintHeader.vue?vue&type=template&id=14cbb80b&scoped=true"
import script from "./observa4PrintHeader.vue?vue&type=script&lang=js"
export * from "./observa4PrintHeader.vue?vue&type=script&lang=js"
import style0 from "./observa4PrintHeader.vue?vue&type=style&index=0&id=14cbb80b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cbb80b",
  null
  
)

export default component.exports